import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { AlertTitle } from "@mui/material";
import Alert from "@mui/material/Alert";
var ErrorNotice = function(param) {
    var error = param.error;
    return /*#__PURE__*/ _jsxs(Alert, {
        severity: "error",
        css: {
            marginBottom: "16px"
        },
        children: [
            /*#__PURE__*/ _jsx(AlertTitle, {
                children: error.name
            }),
            error.message,
            " ",
            /*#__PURE__*/ _jsx("br", {}),
            error.stack
        ]
    });
};
export default ErrorNotice;
